import { sortBy } from 'lodash'

const initialState = {
  transactions: [],
  ui: {
    loading: true
  }
}

export default function transactionHistory(state = initialState, action){
  switch (action.type) {
    case "SUCCESS_FETCH_TRANSACTIONS":
      return {
        ...state,
        transactions: sortBy(action.payload, "id").reverse(),
        ui: {
          loading: false
        }
      }
    case "UPDATE_TRANSACTION_HISTORY_UI":
      return {
        ...state,
        ui: {
          ...state.ui,
          ...action.payload,
        }
      }
    case "ADD_TRANSACTION":
      return {
        ...state,
        transactions: sortBy([
          ...state.transactions,
          action.payload.transaction,
        ], "id").reverse()
      }
    default:
      return state;
  }
} 